import React from 'react';

const Switch = ({ isOn, onToggle, label }) => {
    return (
        <div className="flex flex-col items-center gap-2">
            <button
                onClick={onToggle}
                className="relative w-12 h-8 rounded-sm bg-[#d4d2cc] shadow-[inset_0_1px_3px_rgba(0,0,0,0.1),0_1px_0_rgba(255,255,255,0.5)] p-0.5 transition-all duration-75 active:scale-[0.98]"
            >
                {/* Rocker Body */}
                <div
                    className={`
                        w-full h-full rounded-[2px] relative overflow-hidden transition-all duration-200
                        ${isOn
                            ? 'bg-[#333] shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)]'
                            : 'bg-[#e0e0e0] shadow-[0_2px_4px_rgba(0,0,0,0.1),inset_0_1px_0_rgba(255,255,255,0.8)]'
                        }
                    `}
                >
                    {/* Active State Details */}
                    {isOn && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-1.5 h-1.5 rounded-full bg-[#00ff88] shadow-[0_0_6px_#00ff88] opacity-90"></div>
                        </div>
                    )}

                    {/* Off State Indicators */}
                    {!isOn && (
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-0.5 bg-[#bbb] rounded-full"></div>
                    )}

                    {/* Specular Highlight for Plastic */}
                    <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-white/10 to-transparent pointer-events-none"></div>
                </div>
            </button>
            {label && (
                <span className="text-[9px] font-bold uppercase tracking-widest text-[#666] select-none">
                    {label}
                </span>
            )}
        </div>
    );
};

export default Switch;
